import { useLocation } from "react-router-dom";
import { Anchor, Space, Title } from "@mantine/core";
import ImageMessage from "components/ui/Layout/ImageMessage";
import { MSG } from "constants/msg";

const Welcome: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("n");
  const status = queryParams.get("s");

  return (
    <ImageMessage
      title={`Hello ${name && " " + name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
        },`}
      description={
        status == "pending" ? (
          <Title order={4} fw="normal" mt="md">
            We have noticed that your company&apos;s admin has sent an invite to
            your email for the portal access and this has not yet been accepted.
            <Space h="lg" />
            Please check your email and accept the invite. After this, you
            should receive an email confirming access to the DNA portal. If you
            do not see the invitation in your mailbox, please request your
            company&apos;s admin to resend the invitation.
            <Space h="lg" />
            For any further question, please reach out to{" "}
            <Anchor href={MSG.LINKS.SUPPORT} target="_blank">
              support
            </Anchor>
          </Title>
        ) : (
          <Title order={4} fw="normal" mt="md">
            You do not have access to the DNA portal, please contact your
            company admin. If you are here by mistake and need further
            assistance, please contact{" "}
            <Anchor href={MSG.LINKS.SUPPORT} target="_blank">
              support
            </Anchor>
            .
          </Title>
        )
      }
    />
  );
};

export default Welcome;
